import { supabase } from "./supabase";

export interface SendInvitationParams {
  candidateName: string;
  candidateEmail: string;
  exerciseIds: string[];
  expiresAt: string | null; // ISO
  companyId?: string | null;
  searchId?: string | null;
}

export interface SendInvitationResult {
  assignmentId: string;
  testUrl: string;
  emailSent: boolean;
  emailError?: string;
}

/** Llama la edge function send-invitation. */
export async function sendInvitation(
  params: SendInvitationParams
): Promise<SendInvitationResult> {
  const { data, error } = await supabase.functions.invoke<SendInvitationResult>(
    "send-invitation",
    {
      body: {
        ...params,
        appBaseUrl: window.location.origin,
      },
    }
  );

  if (error) {
    throw new Error(error.message || "Error invocando send-invitation");
  }
  if (!data) {
    throw new Error("Respuesta vacía de la edge function");
  }
  return data;
}

/** Llama send-confirmation (lo invoca el candidato al submitear). */
export async function sendConfirmation(assignmentId: string): Promise<void> {
  const { error } = await supabase.functions.invoke("send-confirmation", {
    body: { assignmentId },
  });
  if (error) {
    // No bloqueamos el flow del candidato si falla el email
    console.warn("send-confirmation falló:", error.message);
  }
}

/** Reenvía la invitación a un assignment existente. */
export async function resendInvitation(
  assignmentId: string
): Promise<{ testUrl: string }> {
  const { data, error } = await supabase.functions.invoke<{
    ok: boolean;
    testUrl: string;
  }>("resend-invitation", {
    body: {
      assignmentId,
      appBaseUrl: window.location.origin,
    },
  });
  if (error) throw new Error(error.message || "Error invocando resend-invitation");
  if (!data) throw new Error("Respuesta vacía");
  return { testUrl: data.testUrl };
}
